import { render, staticRenderFns } from "./FocusTrapPage.vue?vue&type=template&id=e6398e98&"
import script from "./FocusTrapPage.vue?vue&type=script&lang=ts&"
export * from "./FocusTrapPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports